<template>
	<b-form-invalid-feedback :force-show="0 < messages.length" class="mb-1">
		<span v-for="message in messages" :key="message" class="d-block">{{
			message.replace("The", "").replace("{field}", "")
		}}</span>
	</b-form-invalid-feedback>
</template>

<script>
export default {
	name: "invalid-feedback",
	props: {
		messages: Array,
	},
};
</script>
